var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpeningHour(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.002 512.002",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.801 351.335h-9.1v34.267h9.1c22.736-.944 22.718-33.331 0-34.267zM99.351 351.335c-11.267 0-21.149 15.514-21.149 33.2s9.883 33.2 21.149 33.2 21.15-15.514 21.15-33.2-9.884-33.2-21.15-33.2z",
    fill: "#F6A319",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.001 257.068h-482c-8.284 0-15 6.716-15 15v224.934c0 8.284 6.716 15 15 15h482c8.284 0 15-6.716 15-15V272.068c0-8.284-6.716-15-15-15zM99.351 447.735c-27.693 0-51.149-27.248-51.149-63.2 2.449-83.942 99.943-83.713 102.3.001-.001 35.523-23.124 63.199-51.151 63.199zm108.45-32.133h-9.1v17.134c-.793 19.902-29.215 19.887-30 0v-96.4c0-8.284 6.716-15 15-15h24.1c62.544 2.596 62.497 91.692 0 94.266zm112.467-46.067c19.902.793 19.887 29.215 0 30h-17.133v18.2h25.166c19.902.793 19.887 29.215 0 30h-40.166c-8.284 0-15-6.716-15-15v-96.4c0-8.284 6.716-15 15-15h40.166c19.902.793 19.887 29.215 0 30h-25.166v18.2zm135.5 63.2a15 15 0 0 1-27.48 8.32l-36.786-55.179v46.858c-.793 19.902-29.215 19.887-30 0v-96.4a15 15 0 0 1 27.48-8.32l36.786 55.179v-46.858c.793-19.902 29.215-19.887 30 0zM97.277 227.068 235.014 89.321c12.477 6.535 29.497 6.535 41.974 0l137.737 137.748h42.426L298.197 68.102C313.902 37.429 290.611-.33 256 .002c-34.606-.334-57.905 37.433-42.196 68.1L54.851 227.068z",
    fill: "#F6A319",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpeningHour);
export default __webpack_public_path__ + "static/media/opening_hour.b4fc3cf51db1cd4d49ba78eff7128197.svg";
export { ForwardRef as ReactComponent };